import { Component, OnInit, ChangeDetectorRef, Input, inject } from '@angular/core';

import { MultiSubscriptionComponent } from '../multi-subscription-component';
import { AlertService } from './alert.service';
import { Alert, AlertType } from './model';

@Component({
    selector: 'app-alert',
    templateUrl: 'alert.component.html',
    styleUrls: ['./alert.component.scss'],
    standalone: false,
})
export class AlertComponent extends MultiSubscriptionComponent implements OnInit {
    @Input() clientCode: string | undefined;
    @Input() autoDismissErrors = false;

    private readonly alertService = inject(AlertService);
    private readonly cdr = inject(ChangeDetectorRef);

    alert: Alert | undefined;
    showAlert = false;
    defaultAutoDismissTimeout = 3000;
    showDetails = false;
    hasDetails = false;

    ngOnInit(): void {
        this.subscribeTo(this.alertService.getAlert(), (alert: Alert | undefined) => {
            this.alert = alert;
            this.hasDetails = !!alert?.rootCauseMessage;
            this.showAlert = true;
            this.cdr.detectChanges();

            if (this.autoDismissErrors) {
                this.removeAlertAfter(this.defaultAutoDismissTimeout);
            }
        });
    }

    removeAlert(): void {
        this.showAlert = false;
        this.showDetails = false;
        this.hasDetails = false;
        this.cdr.detectChanges();
    }

    removeAlertAfter(timeout: number): void {
        setTimeout(() => {
            this.removeAlert();
        }, timeout);
    }

    cssClass(alert?: Alert): { cssClass?: string, message?: string } {
        if (!alert) {
            return {};
        }

        switch (alert.type) {
            case AlertType.Success:
                return { cssClass: 'icon-notification-success', message: 'success' };
            case AlertType.Error:
                return { cssClass: 'icon-notification-error', message: 'error' };
            case AlertType.Info:
                return { cssClass: 'icon-notification-info', message: 'info' };
            case AlertType.Warning:
                return { cssClass: 'icon-notification-warning', message: 'warning' };
            case AlertType.Message:
                return { cssClass: 'icon-notification-message', message: 'message' };
        }

        return {};
    }
}
